import { useState } from 'react';
import * as moment from 'moment';
import { Alert, Button, FormControl, Modal } from 'react-bootstrap';
import { IBillingDetail } from '@nkr/models/index';
import { ConfirmTableWrapper } from '../styles';
import MaskedInput from "react-maskedinput";

interface IProps {
    show: boolean,
    data: IBillingDetail,
    onConfirmed: (datePaid: string) => void,
    onCancel: () => void
}

const MarkPaid = (props: IProps) => {
    const [datePaid, setDatePaid] = useState(moment().format('MM/DD/YYYY'));

    if (props.data == null)
        return null;

    const handleConfirmed = () => {
        props.onConfirmed(datePaid);
    }

    const handleDatePaidChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        setDatePaid(e.currentTarget.value);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Paid Swap Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' className="text-center">
                    To mark the following swap as paid, please verify the <strong>Date Paid</strong> and then click <strong>Yes</strong>...
                </Alert>

                <ConfirmTableWrapper bordered>
                    <tbody>
                        <tr>
                            <th>TXP Date:</th>
                            <td>{props.data.billableNephrectomy.transplantDate}</td>
                        </tr>

                        <tr>
                            <th>Swap #:</th>
                            <td>{props.data.swapNumber}</td>
                        </tr>

                        <tr>
                            <th>Donor:</th>
                            <td>{props.data.billableNephrectomy.donor.alias} @ {props.data.billableNephrectomy.donor.center.alias}</td>
                        </tr>

                        <tr>
                            <th>Recipient:</th>
                            <td>{props.data.billableNephrectomy.recipient.alias} @ {props.data.billableNephrectomy.recipient.center.alias}</td>
                        </tr>

                        <tr>
                            <th>Claim Type:</th>
                            <td>{props.data.claimType}</td>
                        </tr>

                        <tr>
                            <th style={{ verticalAlign: 'middle' }}>Date Paid:</th>
                            <td>
                                <MaskedInput
                                    className='form-control'
                                    mask='11/11/1111'
                                    placeholder='mm/dd/yyyy'
                                    value={datePaid}
                                    onChange={handleDatePaidChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </ConfirmTableWrapper>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={datePaid == ''} onClick={handleConfirmed}>Yes</Button>
                <Button onClick={props.onCancel}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MarkPaid;